<template>
  <div class="container">
    <div class="row">
      <div class="col 2-col">
        <h2 id="landcover">1. Land Cover</h2>
        <h3>1.1 Land Cover and Land Cover Changes</h3>
        <p>Use this section to better understand long term trends in land use and land cover. Data is available
          from several different datasets, each usually with a different spatial resolution or timeframe.
           By clicking a specific class (for example the "forest" class) you can 
          explore how much forest was lost, stable, and gained in the time period specified. It is also possible to see what the lost forest
          has turned into, and what types of other classes have changed into forest.
        </p>
        <LandCoverAnalysis 
          title="Land Cover Analysis" 
          attribution="Maps: Geofolio Landscape Reports." 
          v-bind:location="location" 
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded" 
           >
        </LandCoverAnalysis>


        <h3>1.2 Change Hotspots</h3>
          <p>Use this map to see the hotspots where your landscape has changed the most in one year.</p>

          <p>To see the hotspots for a specific year, click on the data in the column for that year. For each dataset only the top 25 hotspots larger than 1 hectare appear on the map. The table under the map shows the total area of alerts, including those smaller than 1 hectare. </p>

          <p>Click a hotspot on the map to compare satellite images from before and after the change. Try selecting different time periods to get the best view of how the area has changed. </p>

        <AlertMap 
          title="Annual Change Hotspots" 
          numSlots="9" 
          slotType="yearly" 
          sources="hansen_forest_loss_hotspots,jrc_surface_water_changes" 
          attribution="Maps: Geofolio Landscape Reports. Data: GFW/JRC. Backgrounds: Mapbox/Openstreetmap Contributors [13]/Planet NICFI composites/ESA WorldCover." 
          v-bind:location="location" 
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded" 
           >
        </AlertMap>


      </div>
    </div>
  </div>
</template>

<script>
    /* eslint-disable */
    import LandCoverAnalysis from '@/components/factsheet/LandCoverAnalysis.vue'
    import LandDegradationNeutrality from '@/components/factsheet/LandDegradationNeutrality.vue'
    import AlertMap from '@/components/factsheet/ldr/maps/AlertMap.vue'

    export default {
        name: 'LandCover',
        components: { LandCoverAnalysis, LandDegradationNeutrality, AlertMap },
        props: ['location', 'factsheet', 'loaded'],
        data() {
            return {
              
            }
        },
        created() {
        },
        computed: {
          ldr() {
            if(this.loaded && this.factsheet.data["land_degradation_neutrality"]) {
              return this.factsheet.data["land_degradation_neutrality"]
            } else {
              return null;
            }
          }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style>
div.map {
    width:100%;
    height:450px;
    display:block;
}
</style>